export const BACKGAMON = 'backgammon';
export const DOMINO = 'domino';
export const SPADES = 'spades';
export const RUMMY_RUSH = 'rummyRush';
export const RUMMY_STAR = 'rummyStars';
export const TILEZ = 'tilez';
